import React from 'react';
import styles from '../css/index.module.css';

const InsufficientEvidenceBanner = ({ title, body }) => {
    if (!title && !body) return null;
    return (
        <div className={`${styles.aiWardenStatusBanner} ${styles.aiWardenStatusInfo}`} role="note">
            {title ? <div className={styles.aiWardenStatusBannerTitle}>{title}</div> : null}
            {body ? <p className={styles.aiWardenStatusBannerBody}>{body}</p> : null}
        </div>
    );
};

export default InsufficientEvidenceBanner;
